<template>
  <UserListCard
    v-if="canView"
    :title="$t('label.dashboardUpcomingEvents')"
    :widget="widget"
    :view-all-to="{ name: 'Event' }"
    @retry="loadEvents()"
    @page="loadEvents($event)"
  >
    <b-table
      :items="widget.events"
      :fields="fields"
      primary-key="uuid"
      responsive
      show-empty
    >
      <template #cell(name)="{ item }">
        <span class="upcoming-event-name">{{ item.name }}</span>
      </template>
    </b-table>
  </UserListCard>
</template>
<script>
import UserListCard from "./UserListCard.vue";
import { dashboardService } from "@/services/api/dashboard.service";
import { eventDateDisplay } from "@/models/api/event.model";
import { sessionHelper } from "@/utils";

export default {
  name: "DashboardUpcomingEvents",
  components: { UserListCard },
  props: { permission: { type: Number, default: 0 } },
  data() {
    return {
      widget: {
        events: [],
        total: 0,
        page: 1,
        pageSize: 15,
        loading: true,
        error: false,
      },
      requestId: 0,
    };
  },
  computed: {
    canView() {
      return this.permission >= 1;
    },
    fields() {
      return [
        { key: "name", label: this.$t("label.name") },
        {
          key: "startedAt",
          label: this.$t("label.eventStartedAt"),
          class: "text-nowrap",
        },
        {
          key: "endedAt",
          label: this.$t("label.eventEndedAt"),
          class: "text-nowrap",
        },
        {
          key: "registrationClosedAt",
          label: this.$t("label.eventRegistrationClosedAt"),
          class: "text-nowrap",
        },
        { key: "joinedCount", label: this.$t("label.eventJoinedCount") },
      ];
    },
  },
  watch: {
    canView() {
      this.loadEvents(1);
    },
  },
  created() {
    this.loadEvents();
  },
  beforeDestroy() {
    this.requestId++;
  },
  methods: {
    async loadEvents(page = this.widget.page) {
      const requestId = ++this.requestId;
      const widget = this.widget;
      if (
        !this.canView ||
        sessionHelper.getPermissionLevel("event_admin") < 1
      ) {
        widget.events = [];
        widget.total = 0;
        widget.page = 1;
        widget.loading = false;
        widget.error = false;
        return;
      }
      widget.loading = true;
      widget.error = false;
      try {
        const result = await dashboardService.getUpcomingEvents(
          page,
          widget.pageSize,
        );
        if (!result?.success || !Array.isArray(result.data))
          throw new Error("Invalid upcoming event list.");
        if (requestId !== this.requestId) return;
        widget.events = result.data.map((event) => ({
          uuid: event.uuid,
          name: event.name || event.title || "-",
          startedAt: eventDateDisplay(event.started_at),
          endedAt: eventDateDisplay(event.ended_at),
          registrationClosedAt: event.registration_closed_at
            ? eventDateDisplay(event.registration_closed_at)
            : "-",
          joinedCount: Number(event.joined_count) || 0,
        }));
        widget.total = result.pagination?.total ?? result.data.length;
        widget.page = result.pagination?.current_page || page;
        widget.pageSize = result.pagination?.per_page || widget.pageSize;
      } catch (error) {
        if (requestId === this.requestId) widget.error = true;
      } finally {
        if (requestId === this.requestId) widget.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.upcoming-event-name {
  display: block;
  max-width: 320px;
  overflow-wrap: anywhere;
}
</style>
